import styled from "styled-components";

export const StyledTextarea = styled.textarea.attrs(({ className = "" }) => ({
  className: `input input-ghost !text-green100 w-full p-0 min-h-[5rem] max-h-[9.5rem] font-normal !text-sm focus:outline-none placeholder:text-tertiary disabled:cursor-default ${className}`,
}))``;
